import gql from '@zenbusiness/application-commons-utils/gql';

export const GET_INSTANT_FUNDING_ACCOUNT = gql`
  query instantFundingAccounts($businessEntityUuid: UUID!) {
    instantFundingAccounts(businessEntityUuid: $businessEntityUuid) {
      businessProfileStatus
      isEligibleForTransfers
      accountStatus
      hasAcceptedTerms
      instantFundingCards {
        uuid
        instantFundingAccountUuid
        cardBillingAddress {
          address1
          address2
          state
          city
          country
        }
        cardStatus
        cardReviewStatus
        cardCompany
        cardType
        cardHolderFirstName
        cardHolderLastName
        cardLastFourDigits
        cardExpirationDate
        isCardExpired
        isCardPullEnabled
        isCardPushEnabled
        isSourceCard
        isInstantFundingCardRemoved
        isCardValidForTransfers
        cardCreatedAt
        cardUpdatedAt
      }
    }
  }
`;

export const GET_INSTANT_DEPOSIT_LIMIT = gql`
  query instantFundingAccountsLimit($businessEntityUuid: UUID!) {
    instantFundingAccounts(businessEntityUuid: $businessEntityUuid) {
      transactionMetrics {
        dailyUsageTotal {
          amount
          currency
          formattedAmount
        }
        monthlyUsageTotal {
          amount
          currency
          formattedAmount
        }
        dailyTransferLimit {
          amount
          currency
          formattedAmount
        }
        monthlyTransferLimit {
          amount
          currency
          formattedAmount
        }
        perTransferLimit {
          amount
          currency
          formattedAmount
        }
        minimumTransferLimit {
          amount
          currency
          formattedAmount
        }
        dailyTransferCount
        dailyTransferCountLimit
      }
    }
  }
`;

export const GET_INSTANT_FUNDING_TRANSFER_ROUTINE = gql`
  query instantFundingTransferRoutine($transferRoutineUuid: UUID!) {
    instantFundingTransferRoutine(transferRoutineUuid: $transferRoutineUuid) {
      uuid
      transfers {
        uuid
        transferStatus
        transferAmount {
          amount
          currency
          formattedAmount
        }
        transferInitiatedDatetime
        transferUpdatedDatetime
        transferFailureReason
      }
    }
  }
`;

export const GET_INSTANT_FUNDING_TRANSFER_ROUTINES = gql`
  query instantFundingTransferRoutines($input: BankInstantFundingTransferRoutinesInput!) {
    instantFundingTransferRoutines(input: $input) {
      data {
        uuid
        routineStatus
        amount {
          amount
          currency
          formattedAmount
        }
        createdDatetime
        updatedDatetime
      }
    }
  }
`;
